import { CartListFilterStateEnum } from '../enums/cart-list-filter-state.enum';

export class CartListFilter {

  constructor(public State: CartListFilterStateEnum) {
  }

}
